<template>
    <router-link :to="link" 
    class="text-gray-700 border border-gray-400  hover:bg-gray-100  py-2 px-4 rounded inline-flex items-center outline-none focus:outline-none">
        <span>
            <svg viewBox="0 0 24 24" style="width: 24px; height: 24px;">
                <path
                fill="currentColor"
                d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z"
                />
            </svg>
        </span>
        <span class="mx-1"><slot></slot></span>
    </router-link>
</template>

<script>
export default {
    name: 'ButtonVoltar',
    props: {
        link: String
    },

}
</script>
